<template>
  <el-select
    :value="value"
    value-key="id"
    :disabled="disabled"
    :loading="loading"
    loading-text="Loading versions…"
    :placeholder="placeholder"
    :clearable="clearable"
    aria-label="Switch rate version"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)">
    <el-option
      v-for="v in versions"
      :key="v.id"
      :value="v.id"
      :label="optionLabel(v)" />
  </el-select>
</template>

<script>
import DateMixins from '@/mixins/DateMixins'

export default {
  name: 'select-rate-versions',

  mixins: [DateMixins],

  props: {
    versions: {
      type: Array,
      default: function () { return [] }
    },

    value: {
      type: [Number, String],
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: 'Switch version'
    },

    clearable: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    optionLabel: function (v) {
      var label = 'v' + v.version_no + ' · ' + (v.is_current ? 'Current' : 'Superseded') + ' · Published ' + this.formatDate(v.published_at)
      if (v.is_pinned) {
        label += ' · pinned'
      }
      return label
    }
  }
}
</script>

<style scoped>
.el-select { width: 100%; }
</style>
